const IMG = '/images/contact';

const page = {
  slug: 'contact-form-partners',
  title: 'Become A Partner',
  hero: {
    title: 'Become A Partner',
    // Claire: a display of healthy food, not the gingham-and-bread-basket
    // picnic that partners-hero.webp is. Stand-in until she sends her pick.
    image: '/images/shared/salad-bowls.webp',
  },
  blocks: [
    {
      type: 'text',
      heading: 'Want to Partner Up with Us?',
      paragraphs: [
        'We work with fitness trainers, nutritionists, concierge services, and more.',
        'Want to learn more about how YOU can partner with Square Fare?',
        "We'd love to hear from you!",
      ],
    },
    { type: 'form', formType: 'partners', heading: 'Drop us a line.' },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Visit FAQ', to: '/faqs' },
        { label: 'How To Order', to: '/how-to-order', variant: 'outline' },
      ],
    },
  ],
};

export default page;
